module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-show"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-success"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.preview')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('exercise', {
    attrs: {
      "bareBonesExercise": _vm.CelotnaNaloga,
      "showAnswer": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer bg-success"
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleShowModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.hide')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-primary fade",
    attrs: {
      "id": "modal-import"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(1), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.import')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "import-modal-body"
    }
  }, [(!_vm.successMsg && !_vm.errorMsg) ? [(_vm.isInitial || _vm.isSaving) ? _c('form', {
    staticClass: "uploadForm",
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "dropbox"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "name": "file",
      "disabled": _vm.isSaving,
      "accept": ".tex"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files);
        _vm.fileCount = $event.target.files.length
      }
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('p', [_vm._v("\n                  " + _vm._s(_vm.$t('pages.adminpanel.exercises.loadExercise'))), _c('br'), _vm._v(" " + _vm._s(_vm.$t('pages.adminpanel.exercises.loadExercise2')) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', [_vm._v("\n                  " + _vm._s(_vm.$t('pages.adminpanel.exercises.uploading')) + "\n                ")]) : _vm._e()])]) : _vm._e()] : _c('div', [(_vm.errorMsg) ? _c('div', [_c('div', {
    staticClass: "callout callout-danger"
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.errorMsg.responseJSON.message))])])]) : _c('div', [_c('div', {
    staticClass: "callout callout-success"
  }, [_c('p', [_vm._v(_vm._s(_vm.successMsg.message))])]), _vm._v(" "), (_vm.successMsg.warnings.length > 0) ? _c('div', {
    staticClass: "panel box box-warning"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h4', {
    staticClass: "box-title"
  }, [_c('a', {
    attrs: {
      "id": "warnings-accordion",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseThree"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.successMsg.warnings.length) + " \n                      "), (_vm.successMsg.warnings.length === 1) ? _c('span', [_vm._v("warning")]) : _c('span', [_vm._v("warnings")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', _vm._l((_vm.successMsg.warnings), function(warning, ix) {
    return _c('tr', [_c('td', [_c('p', [_vm._v("\n                            " + _vm._s(ix + 1) + ".\n                            "), _c('b', [_vm._v("On exercise with id " + _vm._s(warning.exercise))]), _vm._v(" "), (warning.lineNumber) ? _c('span', [_vm._v("\n                              at line " + _vm._s(warning.lineNumber) + "\n                            ")]) : _vm._e(), _vm._v(" \n                            : " + _vm._s(warning.message) + "\n                            "), _c('br')]), (!warning.lineNumber) ? _c('div', [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("Context:")]), _vm._v("\n                              " + _vm._s(warning.context) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('p')])])
  }), 0)])])]) : _vm._e()])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.successMsg || _vm.errorMsg) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toUploadForm()
      }
    }
  }, [_vm._v("Back")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleImport()
      }
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-primary fade",
    attrs: {
      "id": "modal-addExec"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(3), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.addNew')))])]), _vm._v(" "), [_c('p', {
    staticClass: "inputExecInfo"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.chooseNewExecInputMethod')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default execTypeButton",
    staticStyle: {
      "margin-bottom": "1em",
      "padding": "10px"
    },
    on: {
      "click": function($event) {
        _vm.newExecInputMethod = 'tex'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.inputMethodLatex')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default execTypeButton",
    staticStyle: {
      "margin-bottom": "1em",
      "padding": "10px"
    },
    on: {
      "click": function($event) {
        _vm.newExecInputMethod = 'interface'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.inputMethodInterface')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default execTypeButton",
    staticStyle: {
      "margin-bottom": "3em",
      "padding": "10px"
    },
    on: {
      "click": function($event) {
        _vm.newExecInputMethod = 'bober'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.inputMethodBober')))])], _vm._v(" "), (_vm.newExecInputMethod == 'tex') ? [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rawLatex),
      expression: "rawLatex"
    }],
    staticClass: "inputLatex",
    domProps: {
      "value": (_vm.rawLatex)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rawLatex = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default submitLatexButton",
    staticStyle: {
      "display": "block",
      "margin-bottom": "2em"
    },
    on: {
      "click": function($event) {
        return _vm.submitExecLatex(_vm.rawLatex)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.latexSave')))])] : _vm._e(), _vm._v(" "), (_vm.newExecInputMethod == 'bober') ? [_c('form', {
    attrs: {
      "id": "boberForm",
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": "file",
      "disabled": _vm.isSaving,
      "accept": ".json",
      "id": "bober-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadBoberFile()
      }
    }
  }), _vm._v(" "), (_vm.isSaving) ? _c('p', [_vm._v("\n                  " + _vm._s(_vm.$t('pages.adminpanel.exercises.uploading')) + "\n                ")]) : _vm._e()])] : _vm._e(), _vm._v(" "), (_vm.newExecInputMethod == 'interface') ? [(_vm.showBasicExecInfo) ? [_c('p', {
    staticClass: "inputExecInfo"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.inputBasicExecInfo')))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "basicExecInfo"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.execID),
      expression: "execID"
    }],
    staticClass: "inputQuestion",
    attrs: {
      "type": "text",
      "placeholder": "ID"
    },
    domProps: {
      "value": (_vm.execID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.execID = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.execSRC),
      expression: "execSRC"
    }],
    staticClass: "inputQuestion",
    attrs: {
      "type": "text",
      "placeholder": "SOURCE"
    },
    domProps: {
      "value": (_vm.execSRC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.execSRC = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "inputQuestion",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("PUBLIC "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.execExposure),
      expression: "execExposure"
    }],
    staticStyle: {
      "margin-left": "1em"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.execExposure) ? _vm._i(_vm.execExposure, null) > -1 : (_vm.execExposure)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.execExposure,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.execExposure = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.execExposure = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.execExposure = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "inputExecInfo"
  }, [_vm._v(" " + _vm._s(_vm.$t('pages.exerciseList.execPreText')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.execPreText),
      expression: "execPreText"
    }],
    staticClass: "inputLatex",
    staticStyle: {
      "min-height": "8em",
      "margin-top": "1em",
      "margin-bottom": "2em"
    },
    domProps: {
      "value": (_vm.execPreText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.execPreText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('p', {
    staticClass: "inputExecInfo",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.addTags')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.execTags),
      expression: "execTags"
    }],
    staticClass: "inputQuestion",
    staticStyle: {
      "display": "inline",
      "margin-bottom": "2em",
      "width": "65%"
    },
    attrs: {
      "placeholder": "TAG-1, TAG-2..."
    },
    domProps: {
      "value": (_vm.execTags)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.execTags = $event.target.value
      }
    }
  })])] : _vm._e(), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [(_vm.showBasicExecInfo) ? _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "display": "block",
      "width": "70%",
      "margin": "0 auto",
      "margin-top": "2em",
      "margin-bottom": "4em"
    },
    on: {
      "click": function($event) {
        _vm.showBasicExecInfo = !_vm.showBasicExecInfo
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.hideBasicInfo')))]) : _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "display": "block",
      "width": "70%",
      "margin": "0 auto",
      "margin-top": "2em",
      "margin-bottom": "4em"
    },
    on: {
      "click": function($event) {
        _vm.showBasicExecInfo = !_vm.showBasicExecInfo
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.showBasicInfo')))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "display": "block",
      "width": "70%",
      "margin": "0 auto",
      "margin-top": "2em",
      "margin-bottom": "4em"
    },
    on: {
      "click": function($event) {
        _vm.addSubExec = !_vm.addSubExec
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.addSubExec')))])])])]), _vm._v(" "), (_vm.addSubExec == true) ? [_c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "choose-exercise-type"
    }
  }, [_c('p', {
    staticClass: "inputExecInfo",
    staticStyle: {
      "margin-bottom": "2em"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.chooseExecType')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "grid",
      "grid-template-columns": "1fr 1fr 1fr 1fr",
      "grid-gap": "0.5em"
    },
    attrs: {
      "id": "execTypes"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "padding": "10px",
      "margin-bottom": "1em"
    },
    on: {
      "click": function($event) {
        _vm.exerciseType = 'numerical'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.typeNumerical')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "padding": "10px",
      "margin-bottom": "1em"
    },
    on: {
      "click": function($event) {
        _vm.exerciseType = 'radio'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.typeRadio')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "padding": "10px",
      "margin-bottom": "1em"
    },
    on: {
      "click": function($event) {
        _vm.exerciseType = 'essay'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.typeEssay')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "padding": "10px",
      "margin-bottom": "1em"
    },
    on: {
      "click": function($event) {
        _vm.exerciseType = 'multichoice'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.typeMultichoice')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "padding": "10px",
      "margin-bottom": "1em"
    },
    on: {
      "click": function($event) {
        _vm.exerciseType = 'likert'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.typeLikert')))])])])] : _vm._e(), _vm._v(" "), ((_vm.newExecInputMethod == 'interface') && (_vm.exerciseType == 'numerical') && _vm.addSubExec) ? [_c('p', {
    staticClass: "inputExecInfo"
  }, [_vm._v("Numerical - " + _vm._s(_vm.$t('pages.exerciseList.execTypeQuestion')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numericalQuestion),
      expression: "numericalQuestion"
    }],
    staticClass: "inputQuestion",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.numericalQuestion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numericalQuestion = $event.target.value
      }
    }
  }), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "1em"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('p', {
    staticClass: "inputExecInfo"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.execInputPrecision')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numericalPrecision),
      expression: "numericalPrecision"
    }],
    staticStyle: {
      "margin": "0em 0em 1em 1em",
      "width": "90%",
      "padding": "0.5em"
    },
    attrs: {
      "type": "number",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.numericalPrecision)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numericalPrecision = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "inputExecInfo"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.execInputAnswer')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numericalAnswer),
      expression: "numericalAnswer"
    }],
    staticStyle: {
      "margin": "0em 0em 1em 1em",
      "width": "90%",
      "padding": "0.5em"
    },
    attrs: {
      "type": "number",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.numericalAnswer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numericalAnswer = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "inputExecInfo",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.execAddHint')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numericalHint),
      expression: "numericalHint"
    }],
    staticClass: "inputQuestion",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.numericalHint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numericalHint = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "display": "block",
      "margin": "0 auto",
      "margin-top": "3em",
      "margin-bottom": "3em"
    },
    on: {
      "click": function($event) {
        return _vm.addSubExecNumerical(_vm.numericalQuestion, _vm.numericalPrecision, _vm.numericalAnswer, _vm.numericalHint)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.finishSubExec')))])] : _vm._e(), _vm._v(" "), ((_vm.newExecInputMethod == 'interface') && (_vm.exerciseType == 'radio') && _vm.addSubExec) ? [_c('p', {
    staticClass: "inputExecInfo"
  }, [_vm._v("Radio - " + _vm._s(_vm.$t('pages.exerciseList.execTypeQuestion')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioQuestion),
      expression: "radioQuestion"
    }],
    staticClass: "inputQuestion",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.radioQuestion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.radioQuestion = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.radioAddAnother == false) ? _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "display": "block",
      "margin": "0 auto",
      "margin-top": "3em",
      "margin-bottom": "3em"
    },
    on: {
      "click": function($event) {
        _vm.radioAddAnother = true
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('pages.exerciseList.radioAddAnswer')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.radioAddAnother == true) ? [_c('table', {
    staticClass: "radioAddAnswer"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('p', {
    staticClass: "inputExecInfo"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.execInputAnswer')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioNewAnswer),
      expression: "radioNewAnswer"
    }],
    staticStyle: {
      "margin": "0em 0em 1em 1em",
      "width": "90%",
      "padding": "0.5em"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.radioNewAnswer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.radioNewAnswer = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "inputExecInfo",
    attrs: {
      "id": "radioNewCheckbox"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.radioAddAnswerIfCorrect')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioNewCheckbox),
      expression: "radioNewCheckbox"
    }],
    staticStyle: {
      "margin": "1em 0em 1em 0em",
      "width": "90%",
      "padding": "0.5em"
    },
    attrs: {
      "id": "True",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.radioNewCheckbox) ? _vm._i(_vm.radioNewCheckbox, null) > -1 : (_vm.radioNewCheckbox)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.radioNewCheckbox,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.radioNewCheckbox = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.radioNewCheckbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.radioNewCheckbox = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-left": "1em",
      "width": "90%",
      "margin-bottom": "1em"
    },
    on: {
      "click": function($event) {
        _vm.radioAddAnother = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.cancel')))])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-left": "1em",
      "width": "90%",
      "margin-bottom": "1em"
    },
    on: {
      "click": function($event) {
        return _vm.radioAddAnswer(_vm.radioNewAnswer, _vm.radioNewCheckbox)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.radioAddAnswer')))])])])])] : _vm._e(), _vm._v(" "), ((_vm.radioAllAnswers.length) > 0) ? [_c('p', {
    staticClass: "inputExecInfo",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.answersSoFar')))]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "soFarAnswers"
    }
  }, _vm._l((_vm.radioAllAnswers), function(answer) {
    return _c('li', {
      key: answer
    }, [_c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "90%"
      }
    }, [_vm._v(" " + _vm._s(answer.an.text.sl) + " | " + _vm._s(answer.an.correct))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('button', {
      staticClass: "btn btn-danger pull-left",
      on: {
        "click": function($event) {
          return _vm.radioDelAnswer(answer.id)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-trash"
    })])])])])])
  }), 0)] : _vm._e(), _vm._v(" "), ((_vm.radioAllAnswers.length) > 0) ? _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "display": "block",
      "margin": "0 auto",
      "margin-bottom": "3em",
      "margin-top": "3em"
    },
    on: {
      "click": function($event) {
        return _vm.addSubExecRadio(_vm.radioQuestion)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.finishSubExec')))]) : _vm._e()] : _vm._e(), _vm._v(" "), ((_vm.newExecInputMethod == 'interface') && (_vm.exerciseType == 'essay') && _vm.addSubExec) ? [_c('p', {
    staticClass: "inputExecInfo"
  }, [_vm._v("Essay - " + _vm._s(_vm.$t('pages.exerciseList.execTypeQuestion')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.essayQuestion),
      expression: "essayQuestion"
    }],
    staticClass: "inputQuestion",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.essayQuestion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.essayQuestion = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "inputExecInfo",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.execInputAnswer')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.essayAnswer),
      expression: "essayAnswer"
    }],
    staticClass: "inputQuestion",
    staticStyle: {
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.essayAnswer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.essayAnswer = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "inputExecInfo",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.execAddHint')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.essayHint),
      expression: "essayHint"
    }],
    staticClass: "inputQuestion",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.essayHint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.essayHint = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "display": "block",
      "margin": "0 auto",
      "margin-top": "3em",
      "margin-bottom": "3em"
    },
    on: {
      "click": function($event) {
        return _vm.addSubExecEssay(_vm.essayQuestion, _vm.essayAnswer, _vm.essayHint)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.finishSubExec')))])] : _vm._e(), _vm._v(" "), ((_vm.newExecInputMethod == 'interface') && (_vm.exerciseType == 'multichoice') && _vm.addSubExec) ? [_c('p', {
    staticClass: "inputExecInfo"
  }, [_vm._v("Multichoice - " + _vm._s(_vm.$t('pages.exerciseList.execTypeQuestion')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.multiQuestion),
      expression: "multiQuestion"
    }],
    staticClass: "inputQuestion",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.multiQuestion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.multiQuestion = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.radioAddAnother == false) ? _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "display": "block",
      "margin": "0 auto",
      "margin-top": "3em",
      "margin-bottom": "3em"
    },
    on: {
      "click": function($event) {
        _vm.radioAddAnother = true
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('pages.exerciseList.radioAddAnswer')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.radioAddAnother == true) ? [_c('table', {
    staticClass: "radioAddAnswer"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('p', {
    staticClass: "inputExecInfo"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.execInputAnswer')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioNewAnswer),
      expression: "radioNewAnswer"
    }],
    staticStyle: {
      "margin": "0em 0em 1em 1em",
      "width": "90%",
      "padding": "0.5em"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.radioNewAnswer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.radioNewAnswer = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "inputExecInfo",
    attrs: {
      "id": "radioNewCheckbox"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.radioAddAnswerIfCorrect')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioNewCheckbox),
      expression: "radioNewCheckbox"
    }],
    staticStyle: {
      "margin": "1em 0em 1em 0em",
      "padding": "0.5em"
    },
    attrs: {
      "id": "True",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.radioNewCheckbox) ? _vm._i(_vm.radioNewCheckbox, null) > -1 : (_vm.radioNewCheckbox)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.radioNewCheckbox,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.radioNewCheckbox = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.radioNewCheckbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.radioNewCheckbox = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-left": "1em",
      "width": "90%",
      "margin-bottom": "1em"
    },
    on: {
      "click": function($event) {
        _vm.radioAddAnother = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.cancel')))])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-left": "1em",
      "width": "90%",
      "margin-bottom": "1em"
    },
    on: {
      "click": function($event) {
        return _vm.multiAddAnswer(_vm.radioNewAnswer, _vm.radioNewCheckbox)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.radioAddAnswer')))])])])])] : _vm._e(), _vm._v(" "), ((_vm.multiAllAnswers.length) > 0) ? [_c('p', {
    staticClass: "inputExecInfo",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.answersSoFar')))]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "soFarAnswers"
    }
  }, _vm._l((_vm.multiAllAnswers), function(m_answer) {
    return _c('li', {
      key: m_answer
    }, [_c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "90%"
      }
    }, [_vm._v(" " + _vm._s(m_answer.an.text.sl) + " | " + _vm._s(m_answer.an.correct))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('button', {
      staticClass: "btn btn-danger pull-left",
      on: {
        "click": function($event) {
          return _vm.multiDelAnswer(m_answer.id)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-trash"
    })])])])])])
  }), 0)] : _vm._e(), _vm._v(" "), ((_vm.multiAllAnswers.length) > 0) ? _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "display": "block",
      "margin": "0 auto",
      "margin-bottom": "3em",
      "margin-top": "3em"
    },
    on: {
      "click": function($event) {
        return _vm.addSubExecMulti(_vm.multiQuestion)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.finishSubExec')))]) : _vm._e()] : _vm._e(), _vm._v(" "), ((_vm.newExecInputMethod == 'interface') && (_vm.exerciseType == 'likert') && _vm.addSubExec) ? [_c('p', {
    staticClass: "inputExecInfo"
  }, [_vm._v("Liket - " + _vm._s(_vm.$t('pages.exerciseList.execTypeQuestion')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.likertQuestion),
      expression: "likertQuestion"
    }],
    staticClass: "inputQuestion",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.likertQuestion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.likertQuestion = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.likertAddAnother == false) ? _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "display": "block",
      "margin": "0 auto",
      "margin-top": "3em",
      "margin-bottom": "3em"
    },
    on: {
      "click": function($event) {
        _vm.likertAddAnother = true
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('pages.exerciseList.radioAddAnswer')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.likertAddAnother == true) ? [_c('table', {
    staticClass: "likertAddAnswer"
  }, [_c('tr', [_c('td', [_c('p', {
    staticClass: "inputExecInfo"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.execInputAnswer')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.likertNewAnswer),
      expression: "likertNewAnswer"
    }],
    staticStyle: {
      "margin": "0em 0em 1em 1em",
      "padding": "0.5em"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.likertNewAnswer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.likertNewAnswer = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-left": "1em",
      "margin-bottom": "1em"
    },
    on: {
      "click": function($event) {
        return _vm.likertAddAnswer(_vm.likertNewAnswer, _vm.likertNewCheckbox)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.radioAddAnswer')))])])])])] : _vm._e(), _vm._v(" "), ((_vm.likertAllAnswers.length) > 0) ? [_c('p', {
    staticClass: "inputExecInfo",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.answersSoFar')))]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "soFarAnswers"
    }
  }, _vm._l((_vm.likertAllAnswers), function(m_answer) {
    return _c('li', {
      key: m_answer
    }, [_c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "90%"
      }
    }, [_vm._v(" " + _vm._s(m_answer.an.text.sl) + " | " + _vm._s(m_answer.an.correct))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('button', {
      staticClass: "btn btn-danger pull-left",
      on: {
        "click": function($event) {
          return _vm.likertDelAnswer(m_answer.id)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-trash"
    })])])])])])
  }), 0)] : _vm._e(), _vm._v(" "), ((_vm.likertAllAnswers.length) > 0) ? _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "display": "block",
      "margin": "0 auto",
      "margin-bottom": "3em",
      "margin-top": "3em"
    },
    on: {
      "click": function($event) {
        return _vm.addSubExecLikert(_vm.likertQuestion)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.finishSubExec')))]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "subExecCountInfo"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "2em",
      "margin-bottom": "4em"
    }
  }, [_c('p', {
    staticClass: "inputExecInfo",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.currentSubExecCnt')) + _vm._s(_vm.subExercises.length))]), _vm._v(" "), (_vm.subExercises.length > 0) ? _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "float": "right",
      "margin-right": "2em"
    },
    on: {
      "click": function($event) {
        _vm.showSubExercises = !_vm.showSubExercises
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.showHideSub')))]) : _vm._e()]), _vm._v(" "), ((_vm.showSubExercises) && (_vm.subExercises.length > 0)) ? _c('div', [_vm._m(4), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "subExecList"
    }
  }, _vm._l((_vm.subExercises), function(exec) {
    return _c('li', {
      key: exec,
      staticClass: "subExercise "
    }, [_c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticClass: "inputExecInfo",
      staticStyle: {
        "width": "25%",
        "text-align": "center"
      }
    }, [_vm._v(" " + _vm._s(exec.ex.type) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "inputExecInfo",
      staticStyle: {
        "width": "25%",
        "text-align": "center"
      }
    }, [_vm._v(" " + _vm._s(exec.ex.text.sl) + " ")]), _vm._v(" "), (exec.ex.type == 'numerical') ? _c('td', {
      staticClass: "inputExecInfo",
      staticStyle: {
        "width": "25%",
        "text-align": "center"
      }
    }, [_vm._v(" " + _vm._s(exec.ex.answers[0].correct) + " ")]) : _vm._e(), _vm._v(" "), ((exec.ex.type == 'radio') || (exec.ex.type == 'multichoice')) ? _c('td', {
      staticClass: "inputExecInfo",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('ul', {
      attrs: {
        "id": "subExecListRadioAnswers"
      }
    }, _vm._l((exec.ex.answers), function(ans) {
      return _c('li', {
        key: ans,
        staticClass: "subExecListRadioAnswer"
      }, [_vm._v(" " + _vm._s(ans.text.sl) + " | " + _vm._s(ans.correct) + " ")])
    }), 0)]) : _vm._e(), _vm._v(" "), (exec.ex.type == 'essay') ? _c('td', {
      staticClass: "inputExecInfo",
      staticStyle: {
        "width": "35%",
        "text-align": "center"
      }
    }, [_vm._v(" " + _vm._s(exec.ex.answers[0]) + " ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "inputExecInfo",
      staticStyle: {
        "width": "15%"
      }
    }, [_c('button', {
      staticClass: "btn btn-danger pull-left",
      on: {
        "click": function($event) {
          return _vm.deleteSubExercise(exec.id)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-trash",
      staticStyle: {
        "float": "right"
      }
    })])])])])])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.showSubExercises) ? _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "display": "block",
      "margin": "0 auto",
      "margin-top": "1em",
      "margin-bottom": "3em"
    },
    on: {
      "click": function($event) {
        return _vm.submitExecInterface(_vm.execID, _vm.execSRC, _vm.execExposure, _vm.execPreText, _vm.execTags)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.finishExec')))]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.successMsg || _vm.errorMsg) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toUploadForm()
      }
    }
  }, [_vm._v("Back")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleAddExercise()
      }
    }
  }, [_vm._v("Close")])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-primary fade",
    attrs: {
      "id": "modal-editAns"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "80%"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "padding-top": "1em"
    }
  }, [((_vm.exerciseType === 'multichoice') && (_vm.multiAllAnswers.length > 0)) ? _c('ul', {
    attrs: {
      "id": "soFarAnswers"
    }
  }, [_c('li', [_vm._v(_vm._s(this.multiAllAnswers[this.ansIndexM].an.text.sl) + " | " + _vm._s(this.multiAllAnswers[this.ansIndexM].an.correct))])]) : _vm._e(), _vm._v(" "), ((_vm.exerciseType === 'radio') && (_vm.radioAllAnswers.length > 0)) ? _c('ul', {
    attrs: {
      "id": "soFarAnswers"
    }
  }, [_c('li', [_vm._v(_vm._s(this.radioAllAnswers[this.ansIndexR].an.text.sl) + " | " + _vm._s(this.radioAllAnswers[this.ansIndexR].an.correct))])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "radioAddAnswer"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('p', {
    staticClass: "inputExecInfo"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.execInputAnswer')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempAnswer),
      expression: "tempAnswer"
    }],
    staticStyle: {
      "margin": "0em 0em 1em 1em",
      "width": "90%",
      "padding": "0.5em"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tempAnswer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tempAnswer = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "inputExecInfo",
    attrs: {
      "id": "radioNewCheckbox"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.radioAddAnswerIfCorrect')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempCheckbox),
      expression: "tempCheckbox"
    }],
    staticStyle: {
      "margin": "1em 0em 1em 0em",
      "width": "90%",
      "padding": "0.5em"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tempCheckbox) ? _vm._i(_vm.tempCheckbox, null) > -1 : (_vm.tempCheckbox)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tempCheckbox,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.tempCheckbox = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.tempCheckbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.tempCheckbox = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-left": "1em",
      "width": "90%",
      "margin-bottom": "1em"
    },
    on: {
      "click": function($event) {
        return _vm.toggleEditAns(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.cancel')))])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-left": "1em",
      "width": "90%",
      "margin-bottom": "1em"
    },
    on: {
      "click": function($event) {
        return _vm.editAnswer(_vm.tempAnswer, _vm.tempCheckbox)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.buttons.save')))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-import-rating"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(5), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.upload')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.loadingCSV) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "50%",
      "left": "50%",
      "margin-top": "-50px",
      "margin-left": "-100px",
      "z-index": "100"
    }
  }, [_c('pulse-loader', {
    attrs: {
      "color": _vm.spinnerColor,
      "size": _vm.spinnerSize
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {}, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.importTitle')))]), _vm._v(" "), [(_vm.isInitial || _vm.isSaving) ? _c('form', {
    staticClass: "ratingCSVForm",
    attrs: {
      "id": "ratingCSVForm",
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "dropbox"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "name": "file",
      "multiple": "",
      "disabled": _vm.isSaving,
      "accept": ".csv"
    },
    on: {
      "change": function($event) {
        _vm.filesChangeRating($event.target.name, $event.target.files);
        _vm.fileCount = $event.target.files.length
      }
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('p', [_vm._v("\n                      " + _vm._s(_vm.$t("pages.exerciseList.dragToUpload")) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', [_vm._v("\n                      " + _vm._s(_vm.$t("pages.exerciseList.uploading")) + "\n                    ")]) : _vm._e()])]) : _vm._e()]], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "height": "200px"
    }
  }, [_c('h4', {}, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.exportTitle')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn btn-app",
    class: _vm.loadingCSV ? 'disabled' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadRatingCSV()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.exerciseList.downloadCSV')) + "\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-upload"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(6), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.upload')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [
    [(_vm.isInitial || _vm.isSaving) ? _c('form', {
      staticClass: "slika",
      attrs: {
        "enctype": "multipart/form-data",
        "novalidate": ""
      }
    }, [_c('div', {
      staticClass: "dropbox"
    }, [_c('input', {
      staticClass: "input-file",
      attrs: {
        "type": "file",
        "name": "file",
        "multiple": "",
        "disabled": _vm.isSaving,
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.filesChangePictures($event.target.name, $event.target.files);
          _vm.fileCount = $event.target.files.length
        }
      }
    }), _vm._v(" "), (_vm.isInitial) ? _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("pages.profile.userpicture.loadPicture")) + "\n                    "), _c('br'), _vm._v(" " + _vm._s(_vm.$t("pages.profile.userpicture.loadPicture2")) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("pages.profile.userpicture.loadPicture2")) + "\n                  ")]) : _vm._e()])]) : _vm._e()]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-editExercise"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(7), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.editexercise.prompt')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('editexercise')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitEdit()
      }
    }
  }, [_vm._v(_vm._s(this.$t('pages.profile.update')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "small-box"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sid),
      expression: "sid"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.dataId')
    },
    domProps: {
      "value": (_vm.sid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('button', {
    staticClass: "btn btn-xs",
    class: {
      'bg-blue': _vm.sqlidentifier === 1
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sqlOption('sqlidentifier', 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.contains')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    class: {
      'bg-blue': _vm.sqlidentifier === 0
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sqlOption('sqlidentifier', 0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.startWith')))])])]), _vm._v(" "), (!_vm.advanced) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleAdvanced()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.showAdvanced')))]) : _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleAdvanced()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.hideAdvanced')))])]), _vm._v(" "), (_vm.advanced) ? _c('div', {
    staticClass: "small-box-footer"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group col-xs-10 margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stitle),
      expression: "stitle"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.title')
    },
    domProps: {
      "value": (_vm.stitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stitle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group col-xs-10 margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sauthor),
      expression: "sauthor"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.author')
    },
    domProps: {
      "value": (_vm.sauthor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sauthor = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group col-xs-10 margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssource),
      expression: "ssource"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.source')
    },
    domProps: {
      "value": (_vm.ssource)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssource = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "margin col-xs-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t('pages.exerciseList.owner')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sowner),
      expression: "sowner"
    }],
    attrs: {
      "type": "selected"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sowner = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Any")]), _vm._v(" "), _c('option', [_vm._v("True")]), _vm._v(" "), _c('option', [_vm._v("False")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 margin"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.options.tags,
      "label": "name",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.tags')
    },
    model: {
      value: (_vm.stags),
      callback: function($$v) {
        _vm.stags = $$v
      },
      expression: "stags"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('button', {
    staticClass: "btn btn-xs",
    class: {
      'bg-blue': _vm.sTagFilter === 'or'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateTagFilter('or')
      }
    }
  }, [_vm._v("or")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    class: {
      'bg-blue': _vm.sTagFilter === 'and'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateTagFilter('and')
      }
    }
  }, [_vm._v("and")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 margin"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.options.tags,
      "label": "name",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.tagsExclude')
    },
    model: {
      value: (_vm.stagsExclude),
      callback: function($$v) {
        _vm.stagsExclude = $$v
      },
      expression: "stagsExclude"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 margin"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.options.lngs,
      "label": "name",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.languages')
    },
    model: {
      value: (_vm.slangs),
      callback: function($$v) {
        _vm.slangs = $$v
      },
      expression: "slangs"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 margin"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.options.types,
      "label": "name",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.types')
    },
    model: {
      value: (_vm.stypes),
      callback: function($$v) {
        _vm.stypes = $$v
      },
      expression: "stypes"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "pull-right margin"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default bg-blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.advancedSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n              " + _vm._s(_vm.$t('pages.exerciseList.search')) + "\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "small",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetSearch()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.reset')))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row margin"
  }, [(!_vm.isModal) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "1em"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleImport()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.importButton')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "1em"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.togglePictures()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.uploadPictures')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "1em"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleRating()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.importRating')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "1em"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleAddExercise()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.addExerciseButton')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "1em"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.manageClassrooms()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.classrooms.manageClassrooms')))]), _vm._v(" "), (_vm.selected.length > 0 && _vm.selectedSubgroup) ? _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v(_vm._s(_vm.selectedSubgroup.name) + "\n            "), _c('span', {
    staticClass: "fa fa-caret-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.selected.length > 0 && !_vm.selectedSubgroup) ? _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.addToSubgroup')) + "\n            "), _c('span', {
    staticClass: "fa fa-caret-down"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.subgroupList), function(sgr) {
    return _c('li', {
      key: 's-list-' + sgr.id
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.updateSubgroup(sgr)
        }
      }
    }, [_vm._v(_vm._s(sgr.name))])])
  }), 0), _vm._v(" "), (_vm.selected.length > 0 && !_vm.selectedSubgroup) ? _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-left": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteExercises()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash"
  })]) : _vm._e(), _vm._v(" "), (_vm.selected.length > 0 && _vm.selectedSubgroup) ? _c('button', {
    staticClass: "btn btn-default bg-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addExercises()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.add')))]) : _vm._e(), _vm._v(" "), (_vm.add) ? _c('label', {
    staticClass: "margin text-green"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.updated')))]) : _vm._e(), _vm._v(" "), (_vm.deleted) ? _c('label', {
    staticClass: "margin text-green"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.deleted')))]) : _vm._e(), _vm._v(" "), (_vm.latexSuccessfullyImported || _vm.interfaceSuccessfullyImported) ? _c('label', {
    staticClass: "margin text-green"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.latexSuccessfullyImported')))]) : _vm._e()]) : _c('div', {
    staticClass: "btn-group"
  }, [(_vm.selected.length > 0 && !_vm.selectedSubgroup) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteExercises()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash"
  })]) : _vm._e(), _vm._v(" "), (_vm.deleted) ? _c('label', {
    staticClass: "margin text-green"
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.deleted')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("pages.exerciseList.nmPerPage")))]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v(_vm._s(this.scount) + "\n                "), _c('span', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatescount(10)
      }
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatescount(25)
      }
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatescount(50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatescount(100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatescount('all')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.showAll')))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body table-responsive no-padding"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [_c('tr', [_c('th', [_c('a', {
    staticClass: "btn btn-xs"
  }, [(_vm.selected.length > 0) ? _c('i', {
    staticClass: "fa fa-minus-square-o icon",
    staticStyle: {
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll(0)
      }
    }
  }) : _c('i', {
    staticClass: "fa fa-check-square-o icon",
    staticStyle: {
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll(1)
      }
    }
  })])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("pages.exerciseList.tableId")) + "\n              "), (_vm.ssortby == 'id') ? _c('span', [(_vm.ssortorder == 'desc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatessortorder('asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.ssortorder == 'asc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatessortorder('desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })]) : _vm._e()]) : _c('span', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updatessortby('id');
        _vm.updatessortorder('asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unsorted"
  })])])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("pages.exerciseList.tableDataId")) + "\n              "), (_vm.ssortby == 'identifier') ? _c('span', [(_vm.ssortorder == 'desc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatessortorder('asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.ssortorder == 'asc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatessortorder('desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })]) : _vm._e()]) : _c('span', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updatessortby('identifier');
        _vm.updatessortorder('asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unsorted"
  })])])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exerciseList.tableTitle')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("pages.exerciseList.tableTags")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("pages.exerciseList.tableAuthor")) + "\n              "), (_vm.ssortby == 'author') ? _c('span', [(_vm.ssortorder == 'desc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatessortorder('asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.ssortorder == 'asc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatessortorder('desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })]) : _vm._e()]) : _c('span', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updatessortby('author');
        _vm.updatessortorder('asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unsorted"
  })])])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("pages.exerciseList.tableSource")) + "\n              "), (_vm.ssortby == 'source') ? _c('span', [(_vm.ssortorder == 'desc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatessortorder('asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.ssortorder == 'asc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatessortorder('desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })]) : _vm._e()]) : _c('span', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updatessortby('source');
        _vm.updatessortorder('asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unsorted"
  })])])]), _vm._v(" "), _c('th', [_c('p', [_vm._v(_vm._s(_vm.$t('pages.reports.reported')))])]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _vm._l((_vm.exercises.results), function(exe, index, index2) {
    return [_c('tr', {
      key: 'er-' + index
    }, [_c('td', [(_vm.forExam) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": exe.exerciseVersionId,
        "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, exe.exerciseVersionId) > -1 : (_vm.selected)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = exe.exerciseVersionId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected = $$c
          }
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": exe.exerciseId,
        "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, exe.exerciseId) > -1 : (_vm.selected)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = exe.exerciseId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(exe.id))]), _vm._v(" "), (!_vm.isModal) ? _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal(exe)
        }
      }
    }, [_vm._v(_vm._s(exe.identifier))])]) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('td', {
      staticStyle: {
        "height": "0px"
      }
    }, [_c('p', [_c('a', {
      staticClass: "collapsed",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion",
        "href": '#collapse' + exe.id,
        "aria-expanded": "false"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openPanel(exe)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(exe.identifier) + "\n                  ")])])]) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('td', {
      staticStyle: {
        "width": "12em"
      },
      attrs: {
        "title": _vm.$options.filters.pickTranslation(exe.title)
      }
    }, [_vm._v("\n                " + _vm._s(_vm._f("pickTranslation")(_vm.shortenTitle(exe.title))) + " "), (exe.title && _vm.$options.filters.pickTranslation(exe.title).length > 24) ? _c('span', [_vm._v("...")]) : _vm._e()]) : (!_vm.isModal) ? _c('td', {
      staticStyle: {
        "width": "15em"
      },
      attrs: {
        "data-widget": "tooltip",
        "title": _vm.$options.filters.pickTranslation(exe.title)
      }
    }, [_vm._v("\n                " + _vm._s(_vm._f("pickTranslation")(_vm.shortenTitle(exe.title))) + " "), (exe.title && _vm.$options.filters.pickTranslation(exe.title).length > 30) ? _c('span', [_vm._v("...")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', _vm._l((exe.tags), function(tag) {
      return _c('span', [_c('div', {
        staticClass: "badge bg-blue"
      }, [_vm._v(_vm._s(tag.name))])])
    }), 0), _vm._v(" "), _c('td', [_vm._v(_vm._s(exe.author))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(exe.source))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "eyeIconReport",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.getReports(exe.exerciseId)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye  "
    })])]), _vm._v(" "), (!_vm.isModal) ? _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editExercise(exe.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })])]) : _vm._e()]), _vm._v(" "), (_vm.isModal) ? _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (exe.id == _vm.isOpen),
        expression: "exe.id == isOpen"
      }],
      key: 'e-modal-' + exe.id
    }, [_c('td', {
      attrs: {
        "colspan": "8"
      }
    }, [_c('div', {
      staticClass: "panel box box-primary panel-collapse collapse",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": 'collapse' + exe.id,
        "aria-expanded": "false"
      }
    }, [_c('div', {
      staticClass: "box-body"
    }, [_c('exercise', {
      attrs: {
        "bareBonesExercise": _vm.CelotnaNaloga,
        "showAnswer": true
      }
    })], 1)])])]) : _vm._e()]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-showReports"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(9), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.reports.reportsOnExec')) + "id: " + _vm._s(_vm.reportExecId))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.tempExerciseReports.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_c('p', [_vm._v("Total: " + _vm._s(_vm.tempExerciseReports.length))]), _vm._v(" "), _c('tbody', [_c('th', [_vm._v(" " + _vm._s(_vm.$t('pages.reports.reportUserId')) + " ")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('pages.reports.reportDescription')) + " ")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('pages.reports.reportStatus')) + " ")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('pages.reports.reportReact')) + " ")]), _vm._v(" "), _vm._l((_vm.tempExerciseReports), function(report) {
    return _c('tr', {
      key: report.status
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(report.userId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "45%"
      }
    }, [_vm._v(_vm._s(report.description))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(report.status))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_c('button', {
      staticClass: "reportReactIcon",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.resolveReport(report.id, report.exerciseId) + _vm.toggleShowReports()
        }
      }
    }, [_vm._v("✓")]), _vm._v(" "), _c('button', {
      staticClass: "reportReactIcon",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.ignoreReport(report.id, report.exerciseId) + _vm.toggleShowReports()
        }
      }
    }, [_vm._v("✕")]), _vm._v(" "), _c('button', {
      staticClass: "reportReactIcon",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.pendingReport(report.id, report.exerciseId) + _vm.toggleShowReports()
        }
      }
    }, [_vm._v("…")])])])
  })], 2)]) : _c('p', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.reports.noReportsFound')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleShowReports()
      }
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin"
  }, [_c('div', {
    staticClass: "col-sm-5",
    staticStyle: {
      "margin-top": "1px"
    }
  }, [(_vm.exercises.totalPageCount > 1) ? _c('tr', [_vm._v("\n          " + _vm._s(_vm.$t("pages.exerciseList.footSentence.senOne")) + " " + _vm._s(_vm.exercises.count) + " " + _vm._s(_vm.$t("pages.exerciseList.footSentence.senTwo")) + " " + _vm._s(_vm.exercises.totalResultsCount) + " " + _vm._s(_vm.$t("pages.exerciseList.footSentence.senThree")) + "\n        ")]) : _c('tr', [_vm._v("\n          " + _vm._s(_vm.$t("pages.exerciseList.footSentence.senOne")) + " " + _vm._s(_vm.exercises.totalResultsCount) + " " + _vm._s(_vm.$t("pages.exerciseList.footSentence.senTwo")) + " " + _vm._s(_vm.exercises.totalResultsCount) + " " + _vm._s(_vm.$t("pages.exerciseList.footSentence.senThree")) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "dataTables_paginate paging_simple_numbers",
    attrs: {
      "id": "example1_paginate"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', [(_vm.exercises.page != 1) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPage(_vm.exercises.page - 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.previous')))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button active"
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('pages.exerciseList.page')) + " " + _vm._s(_vm.exercises.page) + " " + _vm._s(_vm.$t('pages.exerciseList.of')) + " " + _vm._s(_vm.exercises.totalPageCount))])]), _vm._v(" "), _c('li', [(_vm.exercises.page != _vm.exercises.totalPageCount) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPage(_vm.exercises.page + 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.next')))]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v("Error")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "inputExecInfo",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" TYPE ")]), _vm._v(" "), _c('td', {
    staticClass: "inputExecInfo",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" QUESTION ")]), _vm._v(" "), _c('td', {
    staticClass: "inputExecInfo",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" ANSWERS ")]), _vm._v(" "), _c('td', {
    staticClass: "inputExecInfo",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" DEL ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('p', [_vm._v("Edit")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d816993", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d816993"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Library.vue
// module id = 1419
// module chunks = 1